/**
 * PATH: packages/ui/src/components/settings/KeyCap.tsx
 * FILE_ID: UI-SETTINGS-KEYCAP-001
 * PURPOSE: Single keycap pill used by the Settings → Shortcuts reference AND
 *          the customization editor, so both render identical keycaps.
 * WHY: The reference + editor each need the same <kbd> styling; sharing one
 *      component keeps them byte-identical and avoids drift.
 */
import type { ReactNode } from 'react'

export function KeyCap({ children }: { children: ReactNode }) {
  return (
    <kbd className="inline-flex items-center justify-center min-w-[24px] h-6 px-1.5 rounded bg-muted border border-border text-[11px] font-mono font-semibold text-foreground">
      {children}
    </kbd>
  )
}

export default KeyCap
